import { Grid } from "@mui/material";
import React, { useState, useEffect, useRef, useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { MenuItem, Select, FormControl } from "@mui/material";
import axios from "axios";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { L1, L3, L4 } from "../../SvgCollection";
import $ from "jquery";

import Context from "../../Context";
import { useLocation, useParams } from "react-router-dom";
import consts from "../../constant";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};


function Tradeleft({ fullScreen, classic }) {
  const { id } = useParams();

  const [pair, setPair] = useState("");

  useEffect(() => {
    setPair(id);
    setObPointFilter(0);
  }, [id]);

  const theme = useTheme();
  const matchSM = useMediaQuery(theme.breakpoints.up("sm"));

  const { setSelcOrderBook, pointFilter, kucoinSocket, spotConnected,
    orderBookBits, setOrderBookBits, setTriggerPrice, markPrice, obPointFilter, setObPointFilter,
    orderBookAsks, setOrderBookAsks, setFuturePrice
  } =

    useContext(Context);

  const [kucoinToken, setKucoinToken] = useState("");
  const [orderBookPrice, setOrderBookPrice] = useState(0);


  const [valueTab2, setValueTab2] = useState(0);

  const loaction = useLocation();
  const placeRoute = loaction.pathname?.split("/")[1];
  const [num, setNum] = useState([
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
    { n1: "66,922.6" },
  ]);

  const midpoint = Math.floor(num.length / 2);
  const [activeTab, setActiveTab] = useState(0);
  const [oldPair, setOldPair] = useState("");
  const [basasset, setBasasset] = useState("");
  const [markasset, setMarkasset] = useState("");

  const onTabClick = (index) => {
    setActiveTab(index);
  };

  const orderbookSoc = useRef(null);

  function formatNumber(num) {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M"; // Convert to Million
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(2) + "K"; // Convert to Thousand
    } else {
      return num.toString(); // Return as is if < 1,000
    }
  }

  let lastUpdateTime = 0;

  const handleChangeObPointFilter = (event) => {
    setObPointFilter(event.target.value);
  };

  const getOrderBook = async () => {
    try {
      axios.withCredentials = true;
      const symbol =
        placeRoute === "trade"
          ? `${id?.split("_")?.join("-")?.toUpperCase()}`
          : `${id?.split("_")?.join("") + "M"}`;
      const dts = await axios.post(`${consts.BackendUrl}/kucoin/getorderbook`, {
        pair: symbol,
        size: 20,
        type: placeRoute,
      });
      var json = dts.data?.result;
      const poiFil = dts.data?.pointFilter;

      if (poiFil) {
        const isAlready = pointFilterOptions?.find(itm => itm.value === poiFil.value);
        if (!isAlready) {
          if (poiFil.value < 2) {
            setPointFilterOptions([poiFil, ...options])
          } else {
            setPointFilterOptions([...options, poiFil]);
          }
        }
        setObPointFilter(poiFil.value)
      }
      // }
      if (json?.data) {
        const now = Date.now();
        const oneSecond = 1000;
        // Only process if 1 second has passed since last update
        if (now - lastUpdateTime >= oneSecond) {
          lastUpdateTime = now;
          var bits = json?.data?.asks;
          var asks = json?.data?.bids;
          const updatedBits = bits?.map(([price, quantity]) => {
            const total = parseFloat(price) * parseFloat(quantity);
            return [
              price,
              quantity,
              total,
              formatNumber(parseFloat(quantity)),
              formatNumber(total.toFixed(3)),
            ];
          });
          if (bits?.length > 0) {
            setOrderBookBits((prevArray) => {
              // Concatenate the previous array with the new bits, sort in descending order, and slice the first 20 elements
              const updatedArray = [...updatedBits, ...prevArray]
                .slice(0, 20)
                .sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]))

              return updatedArray;
            });
          }
          const updatedAsks = asks?.map(([price, quantity]) => {
            const total = parseFloat(price) * parseFloat(quantity);
            return [
              price,
              quantity,
              total,
              formatNumber(parseFloat(quantity)),
              formatNumber(total.toFixed(3)),
            ];
          });
          if (asks?.length > 0) {
            setOrderBookAsks((prevArray) => {
              // Concatenate the previous array with the new asks, sort in descending order, and slice the first 20 elements
              const updatedArray = [...updatedAsks, ...prevArray]
                .slice(0, 20)
                .sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]))

              return updatedArray;
            });
          }

          // ✅ Do something with the data here
          // console.log('Processed WebSocket data:');
        }
      }
    } catch (error) {
      console.log(error, "error on price");
    }
  };

  const prevIdRef = useRef("");

  useEffect(() => {
    if (!spotConnected || !id || !kucoinSocket?.current || !placeRoute) return;

    const prevId = prevIdRef.current;

    const getFormattedTopic = (symbolId) => {
      if (!symbolId) return null;

      const formatted =
        placeRoute === "future"
          ? symbolId.split("_").join("").toUpperCase() + "M"
          : symbolId.split("_").join("-").toUpperCase();

      return placeRoute === "future"
        ? `/contractMarket/level2Depth50:${formatted}`
        : `/spotMarket/level2Depth50:${formatted}`;
    };

    const unsubscribeTopic = (symbolId) => {
      const topic = getFormattedTopic(symbolId);
      if (topic && kucoinSocket.current?.readyState === WebSocket.OPEN) {
        const msg = {
          id: Date.now(),
          type: "unsubscribe",
          topic,
          response: true,
        };
        kucoinSocket.current.send(JSON.stringify(msg));
        console.log("🛑 Unsubscribed:", topic);
      }
    };

    const subscribeTopic = () => {
      const topic = getFormattedTopic(id);
      if (topic && kucoinSocket.current?.readyState === WebSocket.OPEN) {
        const msg = {
          id: Date.now(),
          type: "subscribe",
          topic,
          response: true,
        };
        kucoinSocket.current.send(JSON.stringify(msg));
        console.log("✅ Subscribed:", topic);
      }
    };

    if (kucoinSocket.current.readyState === WebSocket.OPEN) {
      unsubscribeTopic(prevId);
      subscribeTopic();
    } else {
      kucoinSocket.current.onopen = () => {
        unsubscribeTopic(prevId);
        subscribeTopic();
      };
    }

    prevIdRef.current = id;

    return () => {
      unsubscribeTopic(id);

      if (kucoinSocket.current) {
        kucoinSocket.current.onopen = null;
        kucoinSocket.current.onmessage = null;
        kucoinSocket.current.onerror = null;
        kucoinSocket.current.onclose = null;
      }
    };
  }, [spotConnected, id, kucoinSocket, placeRoute]);


  const boxRef = useRef(null); // Create a ref for the box
  const [boxHeight, setBoxHeight] = useState(0); // State to store the height

  useEffect(() => {
    if (pair) {
      setOldPair(pair);
      // getCurrentOrderBook(pair)
      if (boxRef.current) {
        setBoxHeight(boxRef.current.offsetHeight);
      }

      if (placeRoute == "future") {


        getOrderBook();
        // orderBookFutureSocket();

      } else {
        getOrderBook();
        // if (kucoinSocket && spotConnected) {
        //   orderBookSocket()
        // }
      }
    }
  }, [pair, placeRoute]);

  useEffect(() => {
    if (pair) {
      const sym = pair?.split("_");
      setBasasset(sym[0]);
      setMarkasset(sym[1]);
    }
  }, [pair]);

  const options = [
    { value: 2, data: 0.01 },
    { value: 3, data: 0.001 },
    { value: 4, data: 0.0001 },
    { value: 5, data: 0.00001 }
  ];

  const [pointFilterOptions, setPointFilterOptions] = useState(options);

  return (
    <div className="trade-left orderBook">
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            sx={{
              width: "100%",
              //  height: fullScreen && 'auto !important' || classic && '100% !important' || !matchesXL && '350px !important', overflowY: !matchesXL && 'scroll !important'
            }}
            className="grid-box orderBook-box"
            ref={boxRef}
          >
            <CustomTabPanel
              value={valueTab2}
              index={0}
              style={{ height: "100%" }}
            >
              <Box sx={{ width: "100%" }}>
                <div className="order_flx">
                  <Box className="tb_flx">
                    <div
                      className={`${activeTab === 0 ? "active" : ""}`}
                      onClick={() => onTabClick(0)}
                    >
                      <L1 />
                    </div>
                    <div
                      className={`${activeTab === 2 ? "active" : ""}`}
                      onClick={() => onTabClick(2)}
                    >
                      <L3 />
                    </div>
                    <div
                      className={`${activeTab === 3 ? "active" : ""}`}
                      onClick={() => onTabClick(3)}
                    >
                      <L4 />
                    </div>
                  </Box>
                  <div>
                    <div className="order_sele">
                      <FormControl sx={{ width: "fit-content" }}>
                        <Select
                          fullWidth
                          value={obPointFilter}
                          onChange={handleChangeObPointFilter}
                          sx={{
                            "& .MuiSelect-select": {
                              minWidth: "60px",
                            },
                          }}
                        >
                          {pointFilterOptions?.map((item, i) => <MenuItem key={i} sx={{ fontSize: "12px" }} value={item.value}>
                            {item.data}
                          </MenuItem>)}

                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div
                  className={`order_book_table ${activeTab === 0 ? "first_tab" : ""
                    } ${activeTab === 1 ? "second_tab" : ""}  ${activeTab === 2 ? "third_tab" : ""
                    } ${activeTab === 3 ? "fourth_tab" : ""} `}
                >
                  <div className="other_tab_ctn">
                    <div
                      className="sell_table"
                      style={{
                        height: (fullScreen && "130px") || (classic && "350px"),
                      }}
                    >
                      <TableContainer className="trade-left-table">
                        <Table aria-label="simple table" stickyHeader>
                          <TableHead className="sell_head">
                            <TableRow>
                              <TableCell align="left">
                                Price({markasset}){" "}
                              </TableCell>
                              {matchSM && (
                                <TableCell align="right">
                                  Qty({basasset})
                                </TableCell>
                              )}
                              <TableCell align="right">
                                Total({markasset})
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {orderBookBits?.map((row, ind) => (
                              <TableRow
                                key={ind}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setSelcOrderBook(row);
                                }}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  className={"tr-red"}
                                >
                                  {row?.length > 0 && <>{obPointFilter == 0 ?
                                    Number(row[0])?.toFixed(pointFilter)
                                    :
                                    Number(row[0])?.toFixed(obPointFilter)
                                  }</>}
                                </TableCell>

                                {matchSM && (
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="right"
                                    style={{ color: "var(--clr-font)" }}
                                  >
                                    {row?.length > 0 && row[3]}
                                  </TableCell>
                                )}
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="right"
                                  style={{ color: "var(--clr-font)" }}
                                >
                                  {row?.length > 0 && row[4]}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    <div className={activeTab !== 2 ? 'order_tic' : "display-none"} >
                      {
                        placeRoute == "future" ?
                          <>
                            <div className='price'>
                              <div style={{ fontSize: '12px !important', cursor: "pointer" }} onClick={() => { setFuturePrice($(`.pricesses-${pair?.split("_")?.join("")}M`).text().valueOf() ? $(`.pricesses-${pair?.split("_")?.join("")}M`).text().valueOf() : orderBookPrice); }}
                                className={`pricesses-${pair?.split("_")?.join("")}M`}
                              >{orderBookPrice}</div>
                            </div>
                            <div className="m-price display-1">
                              <div className="display-1">
                                <div className="m-til">
                                  M
                                </div>
                                <div style={{ fontSize: '12px!important' }} className={`markPrice`} > {0}</div>
                              </div>

                              <div className="display-1 ">
                                <div className="m-til">
                                  IN
                                </div>
                                <div style={{ fontSize: '12px!important' }} className={`indexPrice`} > {0}</div>
                              </div>
                            </div>
                          </>
                          :
                          <>
                            <div onClick={() => setTriggerPrice(Math.random(6))} className='display-1 cursor'>
                              <span className='price'>1 {basasset}</span>
                              <span>=</span>
                              <span className='price'>
                                <div style={{ fontSize: '12px' }} className={`pricesses-${pair?.split("_")?.join("")}`} >{markPrice}</div>
                                <span className='price' > {markasset}</span>
                              </span>
                            </div>
                          </>
                      }

                    </div>
                    <div
                      className="buy_table"
                      style={{
                        height: (fullScreen && "130px") || (classic && "340px"),
                      }}
                    >
                      <TableContainer className="trade-left-table">
                        <Table aria-label="simple table" stickyHeader>
                          <TableHead className="buy_head">
                            <TableRow>
                              <TableCell align="left">Price(USDT) </TableCell>
                              <TableCell align="right">Qty(ETH)</TableCell>
                              <TableCell align="right">Total(USDT)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {orderBookAsks?.map((row, ind) => (
                              <TableRow
                                key={ind}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setSelcOrderBook(row);
                                  setFuturePrice("")
                                }}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="left"
                                  className={"tr-green"}
                                >
                                  {row?.length > 0 &&
                                    <>{obPointFilter == 0 ?
                                      Number(row[0])?.toFixed(pointFilter)
                                      :
                                      Number(row[0])?.toFixed(obPointFilter)
                                    }</>}
                                </TableCell>
                                {matchSM && (
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    align="right"
                                    style={{
                                      color: "var(--clr-font)",
                                      paddingRight: "35px",
                                    }}
                                  >
                                    {row?.length > 0 && row[3]}
                                  </TableCell>
                                )}
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="right"
                                  style={{ color: "var(--clr-font)" }}
                                >
                                  {row?.length > 0 && row[4]}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>

              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={valueTab2} index={1}>
              <TableContainer
                className="trade-left-table"
                sx={{ height: fullScreen && "335px !important" }}
              >
                <Table aria-label="simple table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Price(USDT) </TableCell>
                      <TableCell align="right">Amount(ETH)</TableCell>
                      <TableCell align="right">Sum(USDT)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {num.map((row, ind) => (
                      <TableRow
                        key={ind}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className={ind > midpoint ? "tr-green" : "tr-red"}
                      >
                        <TableCell component="th" scope="row" align="left">
                          {row.n1}
                        </TableCell>

                        <TableCell component="th" scope="row" align="right">
                          {row.n1}
                        </TableCell>
                        <TableCell component="th" scope="row" align="right">
                          {row.n1}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

export default Tradeleft;
